import { ObjectMapper } from 'json-object-mapper';
import { IModel } from '../IModel';
import { Model } from '../model';

export class ExitInverviewSettingModel extends Model implements IModel<ExitInverviewSettingModel> {
  public eligibleEmployeeTypes: number[] = [];
  public dashboardByHierarchy: boolean = false;
  public listByHierarchy: boolean = false;

  static create(input: any): ExitInverviewSettingModel {
    return ObjectMapper.deserialize<ExitInverviewSettingModel>(ExitInverviewSettingModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
